import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import ProgessResultView from './ProgessResultView'
import ProgessResultForm from './ProgessResultForm'
import {
  getProgressResult,
  updateProgressResult,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
} from '../../redux/actions/projectProgress'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import CommentForm from './CommentForm'
import CommentView from './CommentView'
import ButtonPanel from '../ButtonPanel'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'
import { cloneDeep } from 'lodash-es'

export default function ProgessResultWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const newRowPrefixKey = 'ADD_ID_'

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    console.log('ProgessResultWidget', _schema, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_schema)
  }, [_schema])

  const isNewRow = (id) => {
    //console.log(id)
    return id.startsWith(newRowPrefixKey)
  }

  const handleCallService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await updateProgressResult(projectId, projectProgressId, request)

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            let _schema = await getProgressResult(projectId, projectProgressId)
            console.log('getProgressResult', _schema)
            onChangeIsEdit(false)
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    let expectedResultList = []
    let extendResultList = []

    data.expectedResult.forEach((element) => {
      if (isNewRow(element.id)) {
        element.id = ''
      }
      expectedResultList.push(element)
    })

    data.extendResult.forEach((element) => {
      if (isNewRow(element.id)) {
        element.id = ''
      }
      extendResultList.push(element)
    })

    //set delete = true
    formSchema.expectedResult.values.forEach((element) => {
      let newItem = expectedResultList.find((item) => item.id === element.id)
      if (newItem === undefined) {
        element.isDelete = true
        expectedResultList.push(element)
      }
    })
    formSchema.extendResult.values.forEach((element) => {
      let newItem = extendResultList.find((item) => item.id === element.id)
      if (newItem === undefined) {
        element.isDelete = true
        extendResultList.push(element)
      }
    })

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      expectedResult: expectedResultList,
      extendResult: extendResultList,
    }

    console.log('request', request)

    handleCallService(request, progressId)
    // formSchema.expectedResult.values = data.expectedResult
    // formSchema.extendResult.values = data.extendResult
    // onChangeIsEdit(false)
  }

  const onSubmitComment = (data) => {
    console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    console.log('request body', request)
    handleCallCommentService(request, progressId)
  }

  const onClearAddNotSave = () => {
    console.log('onClearAddNotSave')

    var newFormSchema = cloneDeep(formSchema)
    let arrExp = [...newFormSchema.expectedResult.values]
    let arrExt = [...newFormSchema.extendResult.values]

    arrExp?.forEach((element, index) => {
      if (isNewRow(element.id)) {
        arrExp.splice(index, 1)
      }
    })

    arrExt?.forEach((element) => {
      if (isNewRow(element.id)) {
        arrExt.splice(index, 1)
      }
    })

    newFormSchema.expectedResult.values = arrExp
    newFormSchema.extendResult.values = arrExt

    setFormSchema(newFormSchema)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.comment?.enableEdit ? (
        <>
          <ProgessResultView schema={formSchema} />

          <hr />
          {isEdit ? (
            <CommentForm
              schema={formSchema.comment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div>
              <CommentView schema={formSchema.comment} />
            </div>
          )}
        </>
      ) : (
        <>
          <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />

          {isEdit ? (
            <ProgessResultForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              onSubmit={handleSubmit(onSubmit)}
              projectId={projectId}
              progressId={progressId}
              setFormSchema={setFormSchema}
            />
          ) : (
            <ProgessResultView schema={formSchema} />
          )}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={
              formSchema?.comment?.enableEdit
                ? formSchema?.comment?.buttonText
                : formSchema.buttonText
            }
            onSave={handleSubmit(formSchema.comment?.enableEdit ? onSubmitComment : onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              onClearAddNotSave()
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

// const schema = {
//   header: 'ผลลัพธ์หรือแนวทาง/วิธีการในการขยายผล/ผลที่คาดว่าจะได้รับ',
//   buttonText: 'ผลลัพธ์หรือแนวทาง/วิธีการในการขยายผล/ผลที่คาดว่าจะได้รับ',
//   expectedResult: {
//     name: 'expectedResult',
//     columnText1: 'ผลที่คาดว่าจะได้รับ',
//     columnText2: 'ผลการดำเนินการ',
//     values: [
//       {
//         id: '1',
//         expectedValue: 'สังคมปลอดโรคภัย',
//         actualValue: '',
//         enableDelete: true,
//         isDelete: false,
//       },
//       {
//         id: '2',
//         expectedValue: 'สังคมเกิดการเรียนรู้',
//         actualValue: '',
//         enableDelete: true,
//         isDelete: false,
//       },
//     ],
//     validators: [
//       {
//         type: 'REQUIRED',
//         errorMessage: 'กรุณากรอก ข้อมูล',
//       },
//     ],
//   },
//   extendResult: {
//     name: 'extendResult',
//     columnText1: 'แนวทางการนำผลที่เกิดขึ้นไปใช้ประโยชน์ หรือการขยายผล',
//     columnText2: 'ผลการดำเนินการ',
//     values: [
//       {
//         id: '1',
//         expectedValue: 'สังคมปลอดโรคภัย',
//         actualValue: '',
//         enableDelete: true,
//         isDelete: false,
//       },
//       {
//         id: '2',
//         expectedValue: 'สังคมเกิดการเรียนรู้',
//         actualValue: '',
//         enableDelete: true,
//         isDelete: false,
//       },
//     ],
//     validators: [
//       {
//         type: 'REQUIRED',
//         errorMessage: 'กรุณากรอก ข้อมูล',
//       },
//     ],
//   },
// }
